import { persistor, store } from "@app-redux/store";
import { logoutThunk } from "@app-redux/thunks/authThunks";
import { queryClient } from "@src/App";
import { resetBypass } from "@src/redux/slices/maintenanceSessionSlice";
import { jwtDecode } from "jwt-decode";

export const isAuthenticatedHook = (): boolean => {
  const token = store.getState().auth.token;
  if (!token) return false;
  try {
    const decoded: any = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    if (decoded.exp < currentTime) {
      return false;
    }
    return true;
  } catch {
    return false;
  }
};

export const cleanupOnLogout = async (): Promise<void> => {
  store.dispatch(logoutThunk());
  store.dispatch(resetBypass());
  queryClient.clear();
  await persistor.purge();
  window.location.reload();
};
